<template>
  <div class="pregled-vsebine">
    <div class="postavitev-izbirnika" v-if="!skrijIzbirnik">
      <div class="izbirnik-stranke">
        <div>
          <IzbirnikStranke v-on:osvezitevIzbranihPodatkovStranke="GetStranka"/>
        </div>
      </div>
    </div>
    <div style="padding-top: 10px" v-if="skrijIzbirnik"/>
    <div style="clear: both"/>
    <div class="flex-container">
      <div class="stil-kartice">
        <kartica-osebni-podatki />
        <div style="clear: both"/>
      </div>
      <div class="stil-kartice" v-if="seznamStatusVlogT2.length > 0" v-loading="nalaganjeStatusVloge">
        <div class="odmik-v-kartici">
          <div>
            <div>
              <p class="open-sans-20pt">
                Hvala za naročilo T-2 storitev!
              </p>
            </div>
          </div>
          <div>
            <div style="padding-top: 20px">
              <p class="navadno-besedilo">
                Postopek priklopa bomo začeli ob podpisani in pravilno izpolnjeni pogodbi.<br>
                O poteku priklopa vas bomo sproti obveščali na vašo kontaktno številko.
              </p>
              <div style="padding-top: 10px">
                <div v-for="statusVloge in seznamStatusVlogT2">
                  <p>
                    Datum prijave:
                    <span class="primarna-barva postavitev-datuma-prijave">
                      {{ statusVloge.datum_prijave }}
                    </span>
                  </p>
                  <p>
                    Pogodba poslana:
                    <span class="primarna-barva postavitev-poslane-pogodbe-datum">
                      {{ statusVloge.pogodba_poslano }}
                    </span>
                  </p>
                  <p>
                    Pogodba vrnjena:
                    <span class="primarna-barva postavitev-pogodba-vrnjeno-datum">
                      {{ statusVloge.pogodba_vrnjeno }}
                    </span>
                  </p>
                  <p>
                    Pogodba veljavna:
                    <span class="primarna-barva postavitev-pogodba-veljavno-datum">
                      {{ statusVloge.pogodba_veljavno }}
                    </span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div style="clear: both"/>
      </div>
      <div class="stil-kartice" v-if="seznamStatusVlogTs.length > 0"
           v-loading="nalaganjeStatusVloge">
        <div class="odmik-v-kartici">
          <div>
            <div>
              <p class="open-sans-20pt">
                Podatki nacionalnega operaterja
              </p>
            </div>
          </div>
          <div>
            <div style="padding-top: 20px">
              <div style="padding-top: 10px">
                <div v-for="statusVloge in seznamStatusVlogTs">
                  <p>
                    Datum preverbe:
                    <span class="primarna-barva postavitev-datuma-preverbe">
                      {{ statusVloge.datum_preverbe }}
                    </span>
                  </p>
                  <p>
                    Izgradnja koncana:
                    <span class="primarna-barva postavitev-izgradnja-koncana">
                      {{ statusVloge.izgradnja_koncana }}
                    </span>
                  </p>
                  <p>
                    Konec preverbe:
                    <span class="primarna-barva postavitev-konec-preverbe">
                      {{ statusVloge.konec_preverbe }}
                    </span>
                  </p>
                  <p>
                    Opomba:
                    <span class="primarna-barva postavitev-status-vloge-opomba">
                      {{ statusVloge.opomba }}
                    </span>
                  </p>
                  <p>
                    Stanje vloge:
                    <span class="primarna-barva postavitev-stanje-vloge">
                      {{ statusVloge.stanje_vloge }}
                    </span>
                  </p>
                  <p>
                    Zacetek gradnje:
                    <span class="primarna-barva postavitev-zacetek-gradnje">
                      {{ statusVloge.zacetek_gradnje }}
                    </span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div style="clear: both"/>
      </div>
      <div class="stil-kartice" v-if="this.seznamNarocnin.length === 0">
        <div class="odmik-v-kartici">
          <div>
            <div>
              <p class="open-sans-20pt">
                Naročniško razmerje
              </p>
            </div>
          </div>
          <div>
            <div>
              <div class="Narocnisko-Razmerje-Center-Text-Box">
                <p class="navadno-besedilo">
                  Niste še povezali naročnine.
                <br/>
                  Povežite jo in urejajte svoje naročniško razmerje iz Mojega T-2 že danes.
                </p>
              </div>
            </div>
          </div>
          <div class="gumb-povezi-narocnino-postavitev">
            <a href="/Mojprofil/Narocnine">
              <el-button class="gumb-potrdi">
                POVEŽITE NAROČNINO
              </el-button>
            </a>
          </div>
        </div>
        <div style="clear: both"/>
      </div>
      <div class="stil-kartice" v-if="this.seznamNarocnin.length > 0">
        <div class="odmik-v-kartici">
          <div class="stil-desnega-naslova">
            <a v-if="!HasPermission('PREPAID_NAROCNINE')" href="/MojT2/UporabnikiInPravice"
               class="brez-stila">
              UPORABNIKI IN PRAVICE
            </a>
            <a v-if="HasPermission('PREPAID_NAROCNINE')" :href="tvT2OttSubscription" class="brez-stila">
              UPORABNIKI IN PRAVICE
            </a>
            <span class="odmik-desne-zgoraj-ikone">
              <img src="/static/img/dashboard/Icon-ionic-md-settings-grey.png">
            </span>
          </div>
          <div style="float: left">
            <div class=" icon-left">
              <p class="open-sans-20pt">
                Naročniško razmerje
              </p>
            </div>
          </div>
          <div style="clear: both"/>
          <div style="padding-top: 10px">
            <div class="navadno-besedilo">
              <p>
                Številka naročnika:
                <span class="postavitev-stevilke-narocnika">
                  {{ this.izbranaStranka }}
                </span>
              </p>
              <p>
                Številka kupca:
                <span class="postavitev-sap-stranke">
                  {{ this.izbranaStrankaSap }}
                </span>
              </p>
              <p>
                Kontaktna oseba:
                <span class="postavitev-kontakt-stranke">
                 {{ this.nazivIzbraneStranke }}
                </span>
              </p>
              <p v-if="this.izbranPaket !== ''">
                <b>
                  Izbran paket:
                </b>
                <span class="postavitev-izbranega-paketa">
                  <b>
                      {{ this.izbranPaket }}
                  </b>
                </span>
              </p>
            </div>
            <div class="odmik-gumba-urejanje-narocnin">
              <a href="/Mojprofil/Narocnine">
                <el-button class="belo-ozadje-gumba">
                  <span>
                    <img src="/static/img/NoPath.png"/>
                  </span>
                  <span>
                    <a class="UREJANJE-NARONIN">
                      UREJANJE NAROČNIN
                    </a>
                  </span>
                </el-button>
              </a>
            </div>
          </div>
        </div>
        <div style="clear: both"/>
      </div>
      <KarticaFiksnaPoraba v-if="this.poslovnaStranka === '1'"
                           :seznamFiksnihSt="seznamFiksnihSt"
                           :izbranSap="this.izbranaStrankaSap"
                           :izbranaStevilka="this.izbranaFiskaTelStevilka" />
      <KarticaUmtsPoraba v-else :seznamUmtsSt="seznamUmtsSt"
                         :izbranSap="this.izbranaStrankaSap"
                         :izbranaStevilka="this.izbranaUmtsTelStevilka" />
      <div style="clear: both"/>
      <div class="stil-kartice" v-if="seznamRacunov.length > 0" v-loading="nalaganjeRacunov">
        <div class="odmik-v-kartici">
          <div class="stil-desnega-naslova">
            <a href="/MojT2/Racuni" class="brez-stila">
              PREGLED RAČUNOV
            </a>
            <span class="odmik-desne-zgoraj-ikone">
              <img src="/static/img/dashboard/Icon-material-unfold-more-grey.png">
            </span>
          </div>
          <div style="float: left">
            <div style="width: 100%" class="icon-left">
              <p class="open-sans-20pt">
                <a href="/MojT2/Racuni" style="color:#EF7D00" target="_blank">
                  Računi (naročniška št : {{ this.izbranaStrankaSap }})
                </a>
              </p>
            </div>
          </div>
          <div style="clear: both"/>
          <div>
            <div>
              <div v-if="prikazTabele === '1'">
                <el-table
                  :row-key="row => row.idVrstica"
                  :data="seznamRacunov"
                  style="width: 100%">
                  <el-table-column
                    prop="KLJUC"
                    width="200px"
                    label="ŠTEVILKA RAČUNA">
                    <template slot-scope="scope">
                      <a href="/MojT2/Racuni" style="color:#EF7D00" target="_blank">
                        {{ scope.row.KLJUC }}
                      </a>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="ZNESEK">
                    <template slot-scope="scope">
                      {{ scope.row.DEBET + ' €' }}
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="DATVAL"
                    width="150px"
                    label="ROK PLAČILA">
                  </el-table-column>
                  <el-table-column
                    label="PLAČANO">
                    <template slot-scope="scope">
                      <span v-if="scope.row.placano_izpis === 'DA'">
                        {{ scope.row.placano_izpis }}
                      </span>
                      <span v-else>
                        <b>
                          {{ scope.row.placano_izpis }}
                          <img src="/static/img/Domov/Icon-awesome-exclamation-triangle-black.png"
                               class="placano-ikona-racuni">
                        </b>
                      </span>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <div v-else>
                <el-table
                  :data="seznamRacunov"
                  :row-key="row => row.idVrstica"
                  :expand-row-keys="expandRowKeys"
                  @expand-change="IzbiraVrsticeZaPrikazPodatkov">
                  <el-table-column
                    prop="KLJUC"
                    label="ŠTEVILKA RAČUNA">
                  </el-table-column>
                  <el-table-column type="expand">
                    <template slot-scope="scope">
                      <div style="padding: 20px">
                        <div>
                          <p>
                            ZNESEK:
                            <span>
                              {{ scope.row.DEBET + ' €' }}
                            </span>
                          </p>
                        </div>
                        <div>
                          <p>
                            PLAČANO
                            <span v-if="scope.row.placano_izpis === 'DA'">
                              {{ scope.row.placano_izpis }}
                            </span>
                            <span v-else>
                              <b>
                                {{ scope.row.placano_izpis }}
                                <img src="/static/img/Domov/Icon-awesome-exclamation-triangle-black.png"
                                     class="placano-ikona-racuni">
                              </b>
                            </span>
                          </p>
                        </div>
                        <div>
                          <p>
                            ROK PLAČILA:
                            <span>
                              {{ scope.row.DATVAL }}
                            </span>
                          </p>
                        </div>
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
          </div>
          <div style="padding-top: 20px" v-if="zapadlePostavke > 0">
            <p>
            <span>
              <img src="/static/img/dashboard/Icon-awesome-exclamation-triangle.png" class="Icon-awesome-info-circle">
              <a class="info-box-poraba">
                <b>POZOR</b>: Na vašem priključku so neporavnane zapadle obveznosti. Prosimo, preverite izdane račune.
              </a>
            </span>
            </p>
          </div>
        </div>
        <div style="clear: both"/>
      </div>
      <div class="stil-kartice" v-if="this.vclanjenostStranke === 'Da'" v-loading="nalaganjeVclanjenostiStranke">
        <div class="odmik-v-kartici">
          <div class="stil-desnega-naslova">
            <a href="/Mojprofil/T2klub" class="brez-stila">
              KLUBSKI PROFIL
            </a>
            <span class="odmik-desne-zgoraj-ikone">
              <img src="/static/img/dashboard/Icon-ionic-md-settings-grey.png">
            </span>
          </div>
          <div style="float: left">
            <div class="icon-left fitter">
              <p class="open-sans-20pt">
                T-2 Klub
              </p>
            </div>
          </div>
          <div style="clear: both"/>
          <div class="odmik-izpisa-klub">
            <div>
              Članstvo:
              <span class="postavitev-status-clanstva">
                {{ this.vclanjenostStranke }}
              </span>
            </div>
            <div>
              Stanje točk:
              <span class="postavitev-stevila-tock">
                {{ this.steviloTock }}
              </span>
            </div>
            <div class="odmik-vsebine-vclanitev">
              <p>
              Zbrane točke lahko unovčite v naši spletni trgovini. Več kot 3.400 izdelkov in storitev za člane ugodneje!
              </p>
            </div>
          </div>
          <div class="postavitev-gumba-vstopite-v-klub">
            <a :href="klubUrl" target="_blank">
              <el-button class="gumb-potrdi mt-5">
                PREVERITE PONUDBO
              </el-button>
            </a>
            <div class="float-right">
              <img src="/static/img/Domov/T2klub_Logo.png" class="t2-icon-klub">
            </div>
          </div>
        </div>
        <div style="clear: both"/>
      </div>
      <permission-component
          :css-class="'stil-kartice'"
          :permission-id="'PRIKLJUCKI'"
          :additional-data-required="true"
          v-if="seznamFiksnihSt.length === 0 && seznamUmtsSt.length === 0 && this.seznamNarocnin.length > 0 &&
           !this.HasPermission('PRIKLJUCEK_OTT_PODATKI', true)">
        <div>
          <div class="odmik-v-kartici">
            <kartica-naroci-mobilno-telefonijo />
          </div>
          <div style="clear: both"/>
        </div>
      </permission-component>
      <permission-component
          :css-class="'stil-kartice'"
          :permission-id="'PRIKLJUCKI'"
          :additional-data-required="true"
          v-if="this.vclanjenostStranke === 'Ne' && !this.HasPermission('PRIKLJUCEK_OTT_PODATKI', true)"
          v-loading="nalaganjeVclanjenostiStranke">
        <div>
          <div class="odmik-v-kartici">
          <kartica-postani-clan :naziv-stranke="this.nazivIzbraneStranke" />
          </div>
         <div style="clear: both"/>
        </div>
      </permission-component>
      <KarticaHitriDostop :podatkiStranke="podatkiStranke" v-if="seznamNarocnin.length > 0 && podatkiStranke !== null" />
      <div style="clear: both"/>
    </div>
    <div class="odmik-levo maksimalna-sirina" v-if="artikliZaIzpis.length > 0">
      <div class="novice" v-for="artikel in artikliZaIzpis">
        <div>
          <a :href="artikel.url">
            <img class="stil-slike-novic" :src="artikel.image_large">
          </a>
          <a :href="artikel.url">
            <p class="stil-naslova-novic">
              {{ artikel.title }}
            </p>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import {PridobivanjeVklopljenoNaroceno} from 'src/assets/js/globalne_funkcije/NarociTelevizija/GetNarocenoVklopljeno.js'
import IzbirnikStranke from '../GlobalneKomponente/IzbirnikStranke.vue'
import {PridobiStranko} from 'src/assets/js/globalne_funkcije/PridobivanjeStranke/PridobiStranko'
import {PridobiNovice} from 'src/assets/js/globalne_funkcije/PridobivanjeNovic/PridobiNovice'
import {PretvorbaEnot} from 'src/assets/js/globalne_funkcije/SplosneGlobalneFunkcije/PretvorbaEnotB.js'
import {FormatirajDatum} from 'src/assets/js/globalne_funkcije/SplosneGlobalneFunkcije/FormatirajDatum'
import {PridobivanjeTock} from 'src/assets/js/globalne_funkcije/Klub/PridobivanjeTock'
import {StrankaVclanjena} from 'src/assets/js/globalne_funkcije/Klub/StrankaVclanjena'
import {PorabaTelefonija} from 'src/assets/js/globalne_funkcije/PorabaTelefonija/PorabaTelefonija'
import {PridobitevRacunov} from 'src/assets/js/globalne_funkcije/Racuni/PridobitevRacunov'
import CircleChartCard from 'src/components/UIComponents/Cards/CircleChartCard.vue'
import ClientAgent from '../../../../assets/js/clientAgent.js'
import {StoritevVrstaEnum} from 'src/assets/js/Enum/StoritevVrstaEnum.js'
import {Select, Option, Tooltip, Button, Table, TableColumn, Collapse, CollapseItem} from 'element-ui'
import {SirinaOkna} from 'src/assets/js/globalne_funkcije/SirinaOkna.js'
import {GetPodatkiIzbirnika} from 'src/assets/js/globalne_funkcije/SplosneGlobalneFunkcije/GetPodatkiIzbirnika.js'
import {PrikazVsebine} from 'src/assets/js/globalne_funkcije/SplosneGlobalneFunkcije/SirinaOkna.js'
import {PridobivanjeStatusVloge} from '../../../../assets/js/globalne_funkcije/StatusVloge/PridobivanjeStatusVloge'
import KarticaHitriDostop from '../../../UIComponents/NaslovnaStran/KarticaHitriDostop'
import {povezave} from '../../../../assets/js/Povezave/povezave'
import KarticaFiksnaPoraba from '../Poraba/Komponente/KarticaFiksnaPoraba'
import KarticaUmtsPoraba from '../Poraba/Komponente/KarticaUmtsPoraba'
import PermissionComponent from '../GlobalneKomponente/PermissionComponent'
import KarticaNarociMobilnoTelefonijo from './Komponente/KarticaNarociMobilnoTelefonijo'
import KarticaOsebniPodatki from './Komponente/KarticaOsebniPodatki'
import { MixinGetUserData } from '../../../../assets/js/globalne_funkcije/PridobitevUporabniskihPodatkovGlobalno/PridobitevUporabniskihPodatkov'
import KarticaPostaniClan from './Komponente/Klub/KarticaPostaniClan'

export default {
  name: 'osnovna',
  mixins: [
    PridobivanjeStatusVloge, GetPodatkiIzbirnika, SirinaOkna, FormatirajDatum, PretvorbaEnot, PridobivanjeTock,
    PridobitevRacunov, PorabaTelefonija, PridobiNovice, PridobivanjeVklopljenoNaroceno,
    StoritevVrstaEnum, StrankaVclanjena, PrikazVsebine, MixinGetUserData
  ],
  data () {
    return {
      clientAgent: null,
      seznamPrikljuckov: [],
      seznamNarocnin: [],
      izbranaStranka: '',
      izbranaStrankaSap: '',
      seznamRacunov: [],
      vseOdprtePostavke: 0,
      zapadlePostavke: 0,
      steviloTock: 0,
      artikliZaIzpis: [],
      pridobljeniArtikli: [],
      seznamTelStevilk: [],
      izbranPrikljucek: '',
      nosilniPrikljucki: [],
      izbranNosilniPrikljucek: '',
      skupnaKolicinaSekund: '',
      skupnaKolicinaZnesek: '',
      emailData: [],
      seznamStoritevVklopljenih: [],
      seznamVklopljenih: [],
      poslovnaStranka: 0,
      prikazTabele: '1',
      mejnaSirinaTabela: 600,
      expandRowKeys: [],
      strankiniPodatkiKlub: '',
      vclanjenostStranke: '',
      izbranaUmtsTelStevilka: '',
      izbranaFiskaTelStevilka: '',
      seznamUmtsSt: [],
      seznamFiksnihSt: [],
      izbranPaket: '',
      naroceneT2Storitve: false,
      nazivIzbraneStranke: '',
      seznamStatusVlogT2: [],
      nalaganjeStatusVloge: true,
      seznamStatusVlogTs: [],
      nalaganjeOsebnihPodatkov: true,
      nalaganjeRacunov: true,
      nalaganjeVclanjenostiStranke: true,
      nalaganjeTelefonskihStevilk: true,
      nalaganjePodatkovTelefonije: true,
      klubUrl: '',
      skrijIzbirnik: false,
      tvT2OttSubscription: '',
      podatkiStranke: null,
      izbranIdPrikljucekZaVloge: ''
    }
  },
  watch: {
    orientacijaPrikazaTabele: function (val) {
      this.prikazTabele = val
    },
    izbranaStranka: function () {
      if (this.izbranaStranka !== null) {
        let param = {}
        param.vmesnik = this
        param.prenesenIzbranId = this.izbranaStranka
        param.prenesenIzbranSap = this.izbranaStrankaSap
        this.PreveriStanjeTock(param)
        this.GetSeznamRacunov(param)
        this.PreverjanjeClanstvo(param)
        this.izbranNosilniPrikljucek = ''
      }
    }
  },
  mounted () {
    this.clientAgent = new ClientAgent()
    this.GetSeznamNovic()
    this.GetSeznamNarocnin()
    this.$nextTick(function () {
      window.addEventListener('resize', this.SirinaOknaPresegaVrednost)
      window.dispatchEvent(new Event('resize'))
    })
    this.klubUrl = povezave.BASE_URL_T2_KLUB
    this.tvT2OttSubscription = povezave.BASE_URL_OTT_TV_T2_SUBSCRIPTION
  },
  components: {
    KarticaPostaniClan,
    KarticaOsebniPodatki,
    PermissionComponent,
    KarticaUmtsPoraba,
    KarticaFiksnaPoraba,
    KarticaHitriDostop,
    'IzbirnikStranke': IzbirnikStranke,
    StoritevVrstaEnum,
    PridobivanjeStatusVloge,
    StrankaVclanjena,
    PridobivanjeVklopljenoNaroceno,
    PridobiNovice,
    FormatirajDatum,
    PridobivanjeTock,
    PridobitevRacunov,
    PorabaTelefonija,
    PridobiStranko,
    GetPodatkiIzbirnika,
    [Select.name]: Select,
    [Option.name]: Option,
    [Tooltip.name]: Tooltip,
    [Button.name]: Button,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem,
    CircleChartCard,
    KarticaNarociMobilnoTelefonijo
  },
  methods: {
    IzbiraVrsticeZaPrikazPodatkov (row) {
      const id = row.idVrstica
      const lastId = this.expandRowKeys[0]
      this.expandRowKeys = id === lastId ? [] : [id]
    },
    MetodaZaKlicNarocenihVkloplenihInStatusVloge () {
      if (this.izbranIdPrikljucekZaVloge !== '') {
        let param = {}
        param.vmesnik = this
        param.prenesenIzbranId = this.izbranIdPrikljucekZaVloge
        param.idVrsta = [
          StoritevVrstaEnum.INTERNET_OPTIKA,
          StoritevVrstaEnum.TELEVIZIJA,
          StoritevVrstaEnum.VARNOST,
          StoritevVrstaEnum.TV_PAKETI,
          StoritevVrstaEnum.TRZNI_PAKET,
          StoritevVrstaEnum.INTERNET_PRD,
          StoritevVrstaEnum.INTERNET_SRD,
          StoritevVrstaEnum.NAROCNISKA_VEZAVA]
        param.idStatusNaroceno = 0
        param.idStatusVklopljeno = 1
        this.GetVklopljeneStoritve(param)
        this.PridobiStatusVloge(param)
        this.nalaganjeStatusVloge = true
      }
    },
    GetStranka (podatkiStranke) {
      if (podatkiStranke !== null) {
        this.podatkiStranke = podatkiStranke
        this.izbranaStranka = podatkiStranke.id_stranka
        this.izbranaStrankaSap = podatkiStranke.id_stranka_sap
        this.nazivIzbraneStranke = podatkiStranke.naziv
        let param = {}
        param.vmesnik = this
        param.prenesenStatusPridobitve = true
        this.PosodobitevPodatkov()
        this.PridobljeniNosilniPrikljucki()
        this.preverjanjeStrankeposlovna = podatkiStranke.poslovna_stranka
        this.poslovnaStranka = podatkiStranke.poslovna_stranka
      } else {
        this.skrijIzbirnik = true
      }
    },
    PridobljeniNosilniPrikljucki () {
      let param = ['idStranka=' + this.izbranaStranka]
      this.clientAgent.postWsRequest(this,
        'stranka/getNosilniPrikljucki?',
        param,
        null,
        'GetNosilniPrikljucki',
        'ErrNosilniPrikljucki')
    },
    GetNosilniPrikljucki (podatki) {
      this.nosilniPrikljucki = []
      this.nosilniPrikljucki = Object.keys(podatki.data)
      this.izbranNosilniPrikljucek = this.nosilniPrikljucki[0]
    },
    ErrNosilniPrikljucki (podatki) {
      this.ShowWarningMessage(podatki)
    },
    getTelefonskeAdmin () {
      if (this.izbranaStrankaSap !== '' && this.izbranaStrankaSap !== null) {
        let request = {
          permissionId: 'ADMIN_PORABA_TELEFONIJA',
          filter: {
            'sap': this.izbranaStrankaSap
          }
        }
        return this.clientAgent.makeRequest(
          'permissions/havePermission',
          request,
          'POST'
        )
      }
    },
    async GetTelefonske () {
      if (this.izbranaStrankaSap !== '' && this.izbranaStrankaSap !== null) {
        this.nalaganjeTelefonskihStevilk = true
        let request = {
          permissionId: 'PORABA_TELEFONIJA',
          filter: {
            'sap': this.izbranaStrankaSap
          }
        }
        let response = await this.clientAgent.makeRequest(
          'permissions/havePermission',
          request,
          'POST'
        )
        if (response.permission.additionalData === null || response.permission.additionalData.length === 0) {
          response = await this.getTelefonskeAdmin()
        }
        this.SetTelefonske(response)
      }
    },
    SetTelefonske (podatki) {
      this.seznamTelStevilk = []
      this.seznamPrikljuckov = []
      this.seznamFiksnihSt = []
      this.seznamUmtsSt = []
      this.izbranIdPrikljucekZaVloge = ''
      this.izbranaFiskaTelStevilka = ''
      this.izbranaUmtsTelStevilka = ''
      if (podatki.permission.additionalData !== null && podatki.permission.additionalData.length > 0) {
        for (let i = 0; i < podatki.permission.additionalData.length; i++) {
          if (podatki.permission.additionalData[i].tip_stevilke === '1' || podatki.permission.additionalData[i].tip_stevilke === 1) {
            this.seznamFiksnihSt.push(podatki.permission.additionalData[i])
            this.izbranaFiskaTelStevilka = podatki.permission.additionalData[i].msisdn
            if (podatki.permission.additionalData[i].sap === this.izbranaStrankaSap) {
              if (typeof podatki.permission.additionalData[i].id_prikljucek === 'undefined') {
                this.izbranIdPrikljucekZaVloge = podatki.permission.additionalData[i].idPrikljucek
              } else {
                this.izbranIdPrikljucekZaVloge = podatki.permission.additionalData[i].id_prikljucek
              }
            }
          } else {
            this.seznamUmtsSt.push(podatki.permission.additionalData[i])
            this.izbranaUmtsTelStevilka = podatki.permission.additionalData[i].msisdn
          }
          if (
            podatki.permission.additionalData[i].sap === this.izbranaStrankaSap &&
            this.izbranIdPrikljucekZaVloge === '' &&
            podatki.permission.additionalData[i].tip_stevilke === '5') {
            this.izbranIdPrikljucekZaVloge = podatki.permission.additionalData[i].id_prikljucek
          }
        }
        for (let i = 0; i < podatki.permission.additionalData.length; i++) {
          if (i === 0) {
            this.izbranPrikljucek = podatki.permission.additionalData[i].id_prikljucek
          }
          this.seznamPrikljuckov.push(podatki.permission.additionalData[i])
        }
      }
      this.MetodaZaKlicNarocenihVkloplenihInStatusVloge()
      this.nalaganjeTelefonskihStevilk = false
    },
    PosodobiIdStranke () {
      if (this.seznamNarocnin.length > 0) {
        for (let i = 0; i < this.seznamNarocnin.length; i++) {
          if (this.seznamNarocnin[i].id_stranka === this.izbranaStranka) {
            this.izbranaStrankaSap = this.seznamNarocnin[i].id_stranka_sap
            break
          }
        }
      }
    },
    SeznamNovic (novicePogostaVprasanja, t2Magazin) {
      this.pridobljeniArtikli = t2Magazin
      for (let i = 0; i < this.pridobljeniArtikli.length; i++) {
        this.artikliZaIzpis.push(this.pridobljeniArtikli[i].article)
      }
    },
    PosodobitevPodatkov () {
      this.vseOdprtePostavke = 0
      this.zapadlePostavke = 0
      this.PosodobiIdStranke()
      this.GetTelefonske()
    },
    PrenosniPodatkiRacuni (prenosniParam, seznamRacunov, vseOdprtePostavke, zapadlePostavke, nalaganje) {
      this.seznamRacunov = seznamRacunov
      let i = 0
      for (const index in seznamRacunov) {
        Vue.set(seznamRacunov[index], 'idVrstica', i++)
      }
      this.vseOdprtePostavke = vseOdprtePostavke
      this.zapadlePostavke = zapadlePostavke
      this.nalaganjeRacunov = false
    },
    PridobiPodatkeTockeKlub (prenosniParam, steviloTock) {
      this.steviloTock = 0
      this.steviloTock = steviloTock
    },
    SetSeznamVkloplenihStoritev (prenosniParametri, seznamVklopljenih) {
      this.seznamVklopljenih = []
      this.izbranPaket = ''
      this.seznamStoritevVklopljenih = []
      this.seznamVklopljenih = seznamVklopljenih
      if (typeof this.seznamVklopljenih !== 'undefined') {
        for (let i = 0; i < this.seznamVklopljenih.length; i++) {
          if (this.seznamVklopljenih[i].idVrsta === parseInt(StoritevVrstaEnum.TRZNI_PAKET)) {
            this.izbranPaket = this.seznamVklopljenih[i].naziv
          }
        }
        for (let i = 0; i < this.seznamVklopljenih.length; i++) {
          this.seznamStoritevVklopljenih.push(this.seznamVklopljenih[i])
        }
        this.izbranaKolicina = []
        if (typeof this.seznamStoritevVklopljenih !== 'undefined') {
          for (let i = 0; i < this.seznamStoritevVklopljenih.length; i++) {
            this.izbranaKolicina[this.seznamStoritevVklopljenih[i].idStoritev] =
              this.seznamStoritevVklopljenih[i].kolicina
          }
        }
        if (typeof this.seznamStoritev !== 'undefined') {
          for (let i = 0; i < this.seznamStoritev.length; i++) {
            if (!(this.seznamStoritev[i].idStoritevVrstaIzbira in this.izbranaKolicina)) {
              this.izbranaKolicina[this.seznamStoritev[i].idStoritevVrstaIzbira] = 0
            }
          }
        }
      }
    },
    PridobiStrankaVclanjena (params, podatkiStrankaKlub, podatkiStrankaKlubPridobivanje, nalaganje) {
      this.strankiniPodatkiKlub = ''
      this.vclanjenostStranke = ''
      this.strankiniPodatkiKlub = params
      if (this.strankiniPodatkiKlub.clanstvo === true) {
        this.vclanjenostStranke = 'Da'
      } else {
        this.vclanjenostStranke = 'Ne'
      }
      this.nalaganjeVclanjenostiStranke = nalaganje
    },
    PridobiStatusVlogePrenosni (prenosniParam, seznamStatusVlog, nalaganje) {
      this.seznamStatusVlogT2 = []
      this.seznamStatusVlogTs = []
      if (typeof seznamStatusVlog.t2 !== 'undefined') {
        this.seznamStatusVlogT2.push(seznamStatusVlog.t2.vloga)
      }
      if (typeof seznamStatusVlog.ts !== 'undefined') {
        this.seznamStatusVlogTs.push(seznamStatusVlog.ts.vloga)
      }
      this.nalaganjeStatusVloge = nalaganje
    },
    PrenosniPodatkiStranke (prenosniParam, seznam) {
      this.seznamNarocnin = 0
      this.seznamNarocnin = seznam.length
    }
  }
}
</script>
<style scoped src="../../../../../static/css/Domov/naslovna-stran.css">
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Domov/NaslovnaStran.vue